import CustomGallery from "./CustomGallery";

export default CustomGallery;
